import React from 'react';
import styles from './settings.module.scss';
export default function Settings() {
  return (
    <div className={styles.wrapper}>Setting</div>
  );
}
